package kz.dentalcrm.app.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.withContext

@Composable
fun <T> ObserveAsEvents(
    flow: Flow<T>,
    key1: Any? = null,
    key2: Any? = null,
    onEvent: (T) -> Unit
) {
    LaunchedEffect(key1, key2, flow) {
        withContext(Dispatchers.Main.immediate) {
            flow.collect(onEvent)
        }
    }
}

@Composable
fun <T> ObserveLatestAsEvents(
    flow: Flow<T>,
    key1: Any? = null,
    key2: Any? = null,
    onEvent: (T) -> Unit
) {
    LaunchedEffect(key1, key2, flow) {
        withContext(Dispatchers.Main.immediate) {
            flow.collectLatest(onEvent)
        }
    }
}
